export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('openFetch:onRequest', (ctx) => {
    const route = nuxtApp._route
    const isTablet = route.path.startsWith('/tablet')
    let token = null
    if (isTablet) {
      token = useLocalStorage('tablet_token', useCookie('tablet_token').value ?? null).value
    }
    else {
      token = useCookie('token', { watch: 'shallow', default: () => null }).value
    }

    if (token === undefined || !token) return

    // Only when there is an impersonate token we use that.
    const impToken = isTablet ? null : useCookie('imp_token').value
    ctx.options.headers.set('Authorization', `Bearer ${impToken ?? token}`)
  })
})
